import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePlatformAdmin } from '@/hooks/usePlatformAdmin';
import { Loader2 } from 'lucide-react';

interface PlatformAdminRouteProps {
  children: ReactNode;
  requiredPermission?: string;
}

/**
 * Route guard for platform admin pages
 * Redirects non-admins to dashboard
 * Optionally checks for specific permissions
 */
export function PlatformAdminRoute({ 
  children, 
  requiredPermission 
}: PlatformAdminRouteProps) {
  const { data: adminInfo, isLoading } = usePlatformAdmin();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!adminInfo?.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredPermission && !adminInfo?.permissions?.[requiredPermission]) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
}
